
import { Tabs } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LeftCircleFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";

import ViewStateService from "../../../services/view-state/ViewStateService";
import ProductApi from "../../../api/ProductApi";
import { GoBackText, GoBackWrapper, ProductDetailsWrapper, ProductNameTitle, TitleBar } from "./ProductDetails.styled";
import ProductBasicInformation from "./components/product-basic-information/ProductBasicInformation";

interface ProductDetailsProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const ProductDetails: React.FC<ProductDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let productApi = new ProductApi();

    // parameters
    let {productId} = useParams();

    // state
    let [product, setProduct] = useState(null);

    // events
    let loadProduct = async ()=> {
        if(!productId) {
            return;
        }
        let product = (await productApi.get(productId)).data.data;
        product.specification = JSON.parse(product.specification);
        setProduct(product);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/product-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // set status bar title
        viewStateService.setStatusBarTitle('产品详情');

        // load product information according to product id parameter
        loadProduct();

    }, []);
    
    // render
    let tabItems = [
        {
            key: 'product-basic-information',
            label: '基础信息',
            children: product && <ProductBasicInformation product={product} />
        }
    ];

    return (
        <ProductDetailsWrapper>
            <TitleBar>
                <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
                </GoBackWrapper>
                <ProductNameTitle>{product?.name}</ProductNameTitle>
            </TitleBar>
    
            { product && 
                <Tabs
                    defaultActiveKey="device-information"
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                />
            }
        </ProductDetailsWrapper>
    )
}

export default ProductDetails;

